import { render, staticRenderFns } from "./ScheduleTab.vue?vue&type=template&id=204a72ac&scoped=true&"
import script from "./ScheduleTab.vue?vue&type=script&lang=js&"
export * from "./ScheduleTab.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleTab.vue?vue&type=style&index=0&id=204a72ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a72ac",
  null
  
)

export default component.exports